var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('ChatMessage',{attrs:{"messages":this.messages,"thereIsImg":this.thereIsImgCliptoBoard}}),_c('BoxCmd',{attrs:{"thereIsImg":this.thereIsImgCliptoBoard,"imgCopied":this.imgCopied},on:{"clearImgCopiedFromObj":_vm.clearImg,"new":_vm.addNewMessage,"pasteImg":_vm.getCliptoBoardImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }